const initialSearchResult = {
  count: 0,
  pageNo: 1,
  pageSize: 20, // APIレスポンスには無いがページングのため
  items: [],
}
export class SearchResult {
  constructor({ count, pageNo, pageSize, items } = initialSearchResult) {
    this.count = count
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.items = items || []
  }
}
